import React, { MouseEventHandler } from 'react';
import { withBaseIcon } from 'react-icons-kit';
import { ic_delete } from 'react-icons-kit/md/ic_delete';
import { arrows_slim_left } from 'react-icons-kit/linea/arrows_slim_left';
import { ic_filter_list } from 'react-icons-kit/md/ic_filter_list';
import { ic_clear } from 'react-icons-kit/md/ic_clear';
import { arrowUnsorted } from 'react-icons-kit/typicons/arrowUnsorted';
import { arrowSortedUp } from 'react-icons-kit/typicons/arrowSortedUp';
import { arrowSortedDown } from 'react-icons-kit/typicons/arrowSortedDown';
import { ic_error } from 'react-icons-kit/md/ic_error';
import { ic_fiber_manual_record } from 'react-icons-kit/md/ic_fiber_manual_record';
import { ic_search } from 'react-icons-kit/md/ic_search';
import { ic_arrow_forward } from 'react-icons-kit/md/ic_arrow_forward';
import { ic_keyboard_arrow_down } from 'react-icons-kit/md/ic_keyboard_arrow_down';
import { ic_keyboard_arrow_right } from 'react-icons-kit/md/ic_keyboard_arrow_right';
import { ic_keyboard_arrow_up } from 'react-icons-kit/md/ic_keyboard_arrow_up';
import { lineArrowLeft } from 'react-icons-kit/oct/lineArrowLeft';
import { lineArrowRight } from 'react-icons-kit/oct/lineArrowRight';
import { eye } from 'react-icons-kit/entypo/eye';
import { withLine } from 'react-icons-kit/entypo/withLine';
import { ic_info_outline } from 'react-icons-kit/md/ic_info_outline';
import { ic_done } from 'react-icons-kit/md/ic_done';
import { ic_help_outline } from 'react-icons-kit/md/ic_help_outline';
import { ic_add_circle_outline } from 'react-icons-kit/md/ic_add_circle_outline';
import { ic_translate } from 'react-icons-kit/md/ic_translate';
import { checkmarkCircled } from 'react-icons-kit/ionicons/checkmarkCircled';
import { androidRadioButtonOff } from 'react-icons-kit/ionicons/androidRadioButtonOff';
import { androidAlert } from 'react-icons-kit/ionicons/androidAlert';
import { ban } from 'react-icons-kit/iconic/ban';
import { androidWarning } from 'react-icons-kit/ionicons/androidWarning';
import { lifebuoy } from 'react-icons-kit/icomoon/lifebuoy';
import { ic_content_copy_outline } from 'react-icons-kit/md/ic_content_copy_outline';
import { ic_open_in_new_outline } from 'react-icons-kit/md/ic_open_in_new_outline';
import { ic_menu } from 'react-icons-kit/md/ic_menu';
import { ic_rule_outline } from 'react-icons-kit/md/ic_rule_outline';

const IconContainer = withBaseIcon({ size: 30 });
interface ArrowProps {
  onClick?: Function;
}

export const Delete = ({ size }: { size?: number }) => (
  <IconContainer
    icon={ic_delete}
    size={size}
    className="text-unlisted-orange"
  />
);
export const BackArrow = () => (
  <IconContainer icon={arrows_slim_left} size={18} />
);
export const NextArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <IconContainer icon={lineArrowRight} size={18} onClick={onClick} />
);
export const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => (
  <IconContainer icon={lineArrowLeft} size={18} onClick={onClick} />
);
export const FilterIcon = () => (
  <IconContainer icon={ic_filter_list} size={20} />
);
export const Clear = () => <IconContainer icon={ic_clear} size={18} />;
export const Clear_Large = () => <IconContainer icon={ic_clear} size={24} />;
// The three sort indicators only ever sit in a table header, which is reversed
// out of brand teal.
export const SortingArrows = () => (
  <IconContainer icon={arrowUnsorted} size={18} className="text-white" />
);
export const SortedUp = () => (
  <IconContainer icon={arrowSortedUp} size={18} className="text-white" />
);
export const SortedDown = () => (
  <IconContainer icon={arrowSortedDown} size={18} className="text-white" />
);
export const NavBarSortedUp = () => (
  <IconContainer
    icon={arrowSortedUp}
    size={18}
    className="text-ui-text-primary-text"
  />
);
export const NavBarSortedDown = () => (
  <IconContainer
    icon={arrowSortedDown}
    size={18}
    className="text-ui-text-primary-text"
  />
);
export const LogsFilterSortedUp = () => (
  <IconContainer
    icon={arrowSortedUp}
    size={18}
    className="text-ui-text-primary-text hover:text-ui-cta-primary"
  />
);
export const LogsFilterSortedDown = () => (
  <IconContainer
    icon={arrowSortedDown}
    size={18}
    className="text-ui-text-primary-text hover:text-ui-cta-primary"
  />
);
export const ProfileDropdown = () => (
  <IconContainer icon={arrowSortedDown} size={18} className="text-white" />
);
export const AttentionIcon = () => (
  <IconContainer icon={ic_error} size={18} className="text-unlisted-orange" />
);
export const HealthyIcon = () => (
  <IconContainer
    icon={ic_fiber_manual_record}
    size={22}
    className="text-brand-accent-green"
  />
);
export const SearchIcon = () => <IconContainer icon={ic_search} size={20} />;
export const ArrowUp = () => (
  <IconContainer
    icon={ic_keyboard_arrow_up}
    size={24}
    className="text-ui-cta-primary"
  />
);
export const ArrowDown = ({ size = 24 }: { size?: number }) => (
  <IconContainer
    icon={ic_keyboard_arrow_down}
    size={size}
    className="text-ui-cta-primary"
  />
);
export const ArrowRight = ({ size = 24 }: { size?: number }) => (
  <IconContainer
    icon={ic_keyboard_arrow_right}
    size={size}
    className="text-ui-cta-primary"
  />
);
export const ArrowForward = ({
  size = 24,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <IconContainer icon={ic_arrow_forward} size={size} className={className} />
);
export const ArrowRightGray = () => (
  <IconContainer
    icon={ic_keyboard_arrow_right}
    size={24}
    className="text-ui-text-primary-text"
  />
);
export const ShowString = () => (
  <IconContainer icon={eye} size={18} className="text-ui-text-primary-text" />
);
export const HideString = () => (
  <IconContainer
    icon={withLine}
    size={18}
    className="text-ui-text-primary-text"
  />
);
export const ToolTipIcon = () => (
  <IconContainer
    icon={ic_info_outline}
    size={18}
    className={'text-ui-text-primary-text hover:text-ui-cta-primary'}
  />
);
export const Checkmark = () => (
  <IconContainer icon={ic_done} size={18} className="text-ui-cta-primary" />
);
export const TranslateIcon = () => (
  <IconContainer icon={ic_translate} size={18} />
);
// The reload control. Hand-drawn rather than react-icons-kit's ic_cached: the
// design supplies its own arrow (a circular arrow with a square head), at 24px
// in Brand Text Secondary. flex-none so it cannot be squeezed by the filter row
// it sits in.
export const RefreshSpinner = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="m-auto block flex-none cursor-pointer text-ui-text-secondary-text transition-colors duration-300 hover:text-ui-cta-primary"
    aria-hidden="true"
  >
    <path
      d="M17.645 6.35C16.195 4.9 14.205 4 11.995 4C7.575 4 4.005 7.58 4.005 12C4.005 16.42 7.575 20 11.995 20C15.725 20 18.835 17.45 19.725 14H17.645C16.825 16.33 14.605 18 11.995 18C8.685 18 5.995 15.31 5.995 12C5.995 8.69 8.685 6 11.995 6C13.655 6 15.135 6.69 16.215 7.78L12.995 11H19.995V4L17.645 6.35Z"
      fill="currentColor"
    />
  </svg>
);
export const CurrentStep = () => (
  <IconContainer
    icon={androidRadioButtonOff}
    size={18}
    className="text-brand-accent-green"
  />
);
export const UnselectedStep = () => (
  <IconContainer
    icon={androidRadioButtonOff}
    size={18}
    className="text-ui-text-primary-text"
  />
);
export const CompletedStep = () => (
  <IconContainer
    icon={checkmarkCircled}
    size={18}
    className="text-brand-accent-green"
  />
);
export const HelpCenterIcon = () => (
  <IconContainer
    icon={lifebuoy}
    size={18}
    className="mx-1 text-ui-cta-primary transition-colors duration-300"
  />
);
export const OpenInNewIcon = () => (
  <IconContainer
    icon={ic_open_in_new_outline}
    size={16}
    className="text-ui-cta-primary"
  />
);
export const CopyToClipboard = () => (
  <IconContainer
    icon={ic_content_copy_outline}
    size={18}
    className="cursor-pointer text-ui-text-primary-text"
  />
);

export const HealthyStatusIcon = () => (
  <IconContainer
    icon={checkmarkCircled}
    size={20}
    className="text-brand-accent-green"
  />
);
// Device-filter states (GUNDI-5178): the pair reads as reaches/blocked wherever a
// rule is summarised, so both live here rather than being restyled per call site.
export const AllowIcon = ({ size = 16 }: { size?: number }) => (
  <IconContainer icon={checkmarkCircled} size={size} className="text-green-1" />
);
export const BlockIcon = ({ size = 16 }: { size?: number }) => (
  <IconContainer icon={ban} size={size} className="text-red-2" />
);
export const UnhealthyStatusIcon = () => (
  <IconContainer
    icon={androidAlert}
    size={20}
    className="text-ui-status-error-destructive"
  />
);
export const DisabledStatusIcon = () => (
  <IconContainer icon={ban} size={20} className="text-ui-text-primary-text" />
);
export const NeedsReviewStatusIcon = () => (
  <IconContainer icon={androidWarning} size={20} className="text-yellow-1" />
);
// GUNDI-5xxx: the left navigation rail's four section icons. Sized 24 so they
// sit inside the rail's 44px active tile; no colour class, so each one inherits
// the tile's text colour (white when active, gray otherwise).
// Pagination chevrons. Handed over as a right-pointing chevron stroked in
// ui-text-secondary-text; "previous" is the same path mirrored, so the pair can
// never drift apart. The colour is fixed rather than inherited: the design
// specifies this teal regardless of the button's own text colour.
const PaginationChevron = ({
  onClick,
  flip,
}: {
  onClick?: MouseEventHandler;
  flip?: boolean;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    onClick={onClick}
    className={`text-ui-text-secondary-text ${flip ? 'rotate-180' : ''}`}
    aria-hidden="true"
  >
    <path
      d="M6 12L10 8L6 4"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PaginationNext = ({
  onClick,
}: {
  onClick?: MouseEventHandler;
}) => <PaginationChevron onClick={onClick} />;
export const PaginationPrev = ({
  onClick,
}: {
  onClick?: MouseEventHandler;
}) => <PaginationChevron onClick={onClick} flip />;

// The rail's four section icons, drawn rather than pulled from the icon set so
// they match the navigation design. Square viewBoxes, so 36px is the longest
// side of each glyph. They fill with `currentColor`, which the rail's tile
// sets: white on the active section, brand text otherwise.
export const NavRoutesIcon = ({ size = 36 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 27 27"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M24 18.27V6C24 2.685 21.315 0 18 0C14.685 0 12 2.685 12 6V21C12 22.65 10.65 24 9 24C7.35 24 6 22.65 6 21V8.73C7.74 8.1 9 6.45 9 4.5C9 2.01 6.99 0 4.5 0C2.01 0 0 2.01 0 4.5C0 6.45 1.26 8.1 3 8.73V21C3 24.315 5.685 27 9 27C12.315 27 15 24.315 15 21V6C15 4.35 16.35 3 18 3C19.65 3 21 4.35 21 6V18.27C19.26 18.885 18 20.535 18 22.5C18 24.99 20.01 27 22.5 27C24.99 27 27 24.99 27 22.5C27 20.55 25.74 18.9 24 18.27ZM4.5 6C3.675 6 3 5.325 3 4.5C3 3.675 3.675 3 4.5 3C5.325 3 6 3.675 6 4.5C6 5.325 5.325 6 4.5 6ZM22.5 24C21.675 24 21 23.325 21 22.5C21 21.675 21.675 21 22.5 21C23.325 21 24 21.675 24 22.5C24 23.325 23.325 24 22.5 24Z"
      fill="currentColor"
    />
  </svg>
);
export const NavConnectionsIcon = ({ size = 36 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M1.5 27V31.5H6C6 29.01 3.99 27 1.5 27ZM1.5 21V24C5.64 24 9 27.36 9 31.5H12C12 25.695 7.305 21 1.5 21ZM1.5 15V18C8.955 18 15 24.045 15 31.5H18C18 22.38 10.605 15 1.5 15ZM31.5 4.5H4.5C2.85 4.5 1.5 5.85 1.5 7.5V12H4.5V7.5H31.5V28.5H21V31.5H31.5C33.15 31.5 34.5 30.15 34.5 28.5V7.5C34.5 5.85 33.15 4.5 31.5 4.5ZM7.5 10.5V13.5H25.5V22.5H21V25.5H28.5V10.5H7.5Z"
      fill="currentColor"
    />
  </svg>
);
export const NavSourcesIcon = ({ size = 36 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 9H33V6H6C4.35 6 3 7.35 3 9V25.5H0V30H21V25.5H6V9ZM34.5 12H25.5C24.675 12 24 12.675 24 13.5V28.5C24 29.325 24.675 30 25.5 30H34.5C35.325 30 36 29.325 36 28.5V13.5C36 12.675 35.325 12 34.5 12ZM33 25.5H27V15H33V25.5Z"
      fill="currentColor"
    />
  </svg>
);
export const NavWorkspacesIcon = ({ size = 36 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M18 10.5V4.5H3V31.5H33V10.5H18ZM9 28.5H6V25.5H9V28.5ZM9 22.5H6V19.5H9V22.5ZM9 16.5H6V13.5H9V16.5ZM9 10.5H6V7.5H9V10.5ZM15 28.5H12V25.5H15V28.5ZM15 22.5H12V19.5H15V22.5ZM15 16.5H12V13.5H15V16.5ZM15 10.5H12V7.5H15V10.5ZM30 28.5H18V25.5H21V22.5H18V19.5H21V16.5H18V13.5H30V28.5ZM27 16.5H24V19.5H27V16.5ZM27 22.5H24V25.5H27V22.5Z"
      fill="currentColor"
    />
  </svg>
);
export const RuleConfiguredIcon = () => (
  <IconContainer
    icon={ic_rule_outline}
    size={18}
    className="text-ui-cta-primary"
  />
);
export const CreateNewDestinationIcon = () => (
  <IconContainer
    icon={ic_add_circle_outline}
    size={40}
    className="text-ui-cta-primary"
  />
);
export const OneDirectionIcon = ({
  size = 36,
  className,
}: {
  size?: number | string;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
    <path
      d="M18 10L16.59 11.41L22.17 17H10V19H22.17L16.59 24.59L18 26L26 18L18 10Z"
      fill="currentColor"
    />
  </svg>
);
